import { Component, OnInit, EventEmitter, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-titolo-filter',
  templateUrl: './titolo-filter.component.html',
  styleUrls: ['./titolo-filter.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TitoloFilterComponent),
      multi: true
    }
  ]
})
export class TitoloFilterComponent implements OnInit {
  titolo: string;
  @Output() confirmNotify: EventEmitter<any> = new EventEmitter<any>();
  @Output() quitNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  confirm() {
    this.confirmNotify.emit({ q: { field: 'titolo', value: this.titolo, regex: true }, t: { k: 'TITOLO', v: this.titolo, l: 'titolo' } });
  }

  enter(e) {
    if (e) e.preventDefault();

    if (this.titolo) {
      this.confirm()
    }
  }

  quit() {
    this.quitNotify.emit();
  }

  ngOnInit() {
  }

  private propagateChange = (_: any) => { };

  public writeValue(s: string) {
    this.titolo = s;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/helpers/filters/titolo-filter/titolo-filter.component.ts